import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4 18.181v-8.12c0-.607.297-1.175.792-1.512l6.222-4.244a1.745 1.745 0 0 1 1.972 0l6.222 4.244c.495.337.792.905.792 1.513v8.12m-16 0C4 19.185 4.796 20 5.778 20h12.444c.982 0 1.778-.814 1.778-1.819m-16 0 6-4.091m10 4.091-6-4.091m-4 0L4 9.998m6 4.092 1.014.691a1.745 1.745 0 0 0 1.972 0L14 14.09m0 0 6-4.092",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render };